// extracted by mini-css-extract-plugin
export default {"WGElement":"WidgetsSettingsElement_WGElement__lub75"};